module.exports = __webpack_public_path__ + "static/media/octes8h_2.da2e316a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/octes/octes8h_2.svg
// module id = 747
// module chunks = 0